import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    /* c8 ignore next */
    trackPageView(location.pathname, typeof document !== 'undefined' ? document.title : '');
    // only depend on pathname changes
  }, [location.pathname]);
}
